import client from '@/lib/axios-client'
import type {
	Contract,
	ContractListResponse,
	ContractsListParams,
	CreateContractBody,
	UpdateContractBody,
} from '@/types/contracts'

const CONTRACTS_URL = '/contracts'

// ── GET /contracts ────────────────────────────────────────────────────────────

export async function getContracts(
	params?: ContractsListParams,
): Promise<ContractListResponse> {
	const response = await client.get(CONTRACTS_URL, { params })
	return response.data.data
}

// ── GET /contracts/:id ────────────────────────────────────────────────────────

export async function getContractById(id: string): Promise<Contract> {
	const response = await client.get(`${CONTRACTS_URL}/${id}`)
	return response.data.data
}

// ── POST /contracts ───────────────────────────────────────────────────────────

export async function createContract(
	body: CreateContractBody,
): Promise<Contract> {
	const response = await client.post(CONTRACTS_URL, body)
	return response.data.data
}

// ── PATCH /contracts/:id ──────────────────────────────────────────────────────

export async function updateContract(
	id: string,
	body: UpdateContractBody,
): Promise<Contract> {
	const response = await client.patch(`${CONTRACTS_URL}/${id}`, body)
	return response.data.data
}

// ── DELETE /contracts/:id ─────────────────────────────────────────────────────

export async function deleteContract(id: string): Promise<void> {
	await client.delete(`${CONTRACTS_URL}/${id}`)
}
